import { Icon } from 'bold-ui'
import CheckPermission from 'components/auth/CheckPermission'
import { PageContent } from 'components/layout/PageContent'
import { PageHeaderSection } from 'components/PageHeaderSection'
import { ButtonLink } from 'components/route'
import { useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions.generated'

import { ProfissionalTable } from './ProfissionalTable'

export function ProfissionalListView() {
  const match = useRouteMatch()

  return (
    <>
      <PageHeaderSection
        title='Profissionais'
        action={
          <CheckPermission permission={Permissions.visualizarProfissionais.cadastrarEditarEExcluir}>
            <ButtonLink to={`${match.url}/create`} kind='primary'>
              <Icon icon='plus' style={{ marginRight: '0.5rem' }} />
              Cadastrar profissional
            </ButtonLink>
          </CheckPermission>
        }
      />

      <PageContent>
        <ProfissionalTable />
      </PageContent>
    </>
  )
}

export default ProfissionalListView
